import LockIcon from "@mui/icons-material/Lock";

export const lock = (props) => {
  return <LockIcon {...props} />;
};
